import React, { Suspense, lazy } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import GlobalBackground from "./components/GlobalBackground";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { WebSocketProvider } from "./context/WebSocketContext";

import BetaGate from "./components/BetaGate";
import CookieNotice from "./components/CookieNotice";

// Páginas carregadas sob demanda (o site abre mais rápido: o painel admin, a wiki e o marketplace só baixam quando você entra nelas)
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const Recover = lazy(() => import("./pages/Recover"));
const Panel = lazy(() => import("./pages/Panel"));
const Ranking = lazy(() => import("./pages/Ranking"));
const Captures = lazy(() => import("./pages/Captures"));
const Players = lazy(() => import("./pages/Players"));
const PlayerDetail = lazy(() => import("./pages/PlayerDetail"));
const Admin = lazy(() => import("./pages/Admin"));
const Shop = lazy(() => import("./pages/Shop"));
const NewsDetail = lazy(() => import("./pages/NewsDetail"));
const Support = lazy(() => import("./pages/Support"));
const Legal = lazy(() => import("./pages/Legal"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Refund = lazy(() => import("./pages/Refund"));
const Game = lazy(() => import("./pages/Game"));
const RmtMarketplace = lazy(() => import("./pages/RmtMarketplace"));
const Roadmap = lazy(() => import("./pages/Roadmap"));
const Wiki = lazy(() => import("./pages/Wiki"));
const GMPanel = lazy(() => import("./pages/GMPanel"));

export default function App() {
  return (
    <BrowserRouter>
      <WebSocketProvider>
        <LanguageProvider>
          <ThemeProvider>
            <AuthProvider>
              <GlobalBackground />
              <CookieNotice />
              <Layout>
                <BetaGate>
                <Suspense fallback={<div style={{ minHeight: "40vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8" }}>Carregando...</div>}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/recover" element={<Recover />} />
                  <Route path="/panel" element={<Panel />} />
                  <Route path="/ranking" element={<Ranking />} />
                  <Route path="/capturas" element={<Captures />} />
                  <Route path="/roadmap" element={<Roadmap />} />
                  <Route path="/wiki" element={<Wiki />} />
                  <Route path="/wiki/:section" element={<Wiki />} />
                  <Route path="/wiki/:section/:id" element={<Wiki />} />
                  <Route path="/support" element={<Support />} />
                  <Route path="/legal" element={<Legal />} />
                  <Route path="/privacidade" element={<Privacy />} />
                  <Route path="/reembolso" element={<Refund />} />
                  <Route path="/players" element={<Players />} />
                  <Route path="/players/:name" element={<PlayerDetail />} />
                  <Route path="/news/:id" element={<NewsDetail />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/rmt-marketplace" element={<RmtMarketplace />} />
                  <Route path="/rmt-bazar" element={<RmtMarketplace />} />
                  <Route path="/bazar" element={<RmtMarketplace />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/gm" element={<GMPanel />} />
                  <Route path="/game" element={<Game />} />
                </Routes>
                </Suspense>
                </BetaGate>
              </Layout>
              <Toaster position="top-right" theme="dark" richColors />
            </AuthProvider>
          </ThemeProvider>
        </LanguageProvider>
      </WebSocketProvider>
    </BrowserRouter>
  );
}
